// Battles API helpers — isolated from the main api wrapper to keep
// the add-on cleanly removable. Re-uses the shared axios instance.
import { api } from "@/lib/api";

export async function issueChallenge(payload) {
  const r = await api.post("/battles/challenge", payload);
  return r.data;
}

export async function acceptChallenge(battleId, accept = true) {
  const r = await api.post(`/battles/${battleId}/accept`, { accept });
  return r.data;
}

export async function cancelChallenge(battleId) {
  const r = await api.post(`/battles/${battleId}/cancel`, {});
  return r.data;
}

export async function getBattle(battleId) {
  const r = await api.get(`/battles/${battleId}`);
  return r.data;
}

export async function listBattles(stateFilter = null, { mineOnly = false } = {}) {
  const params = {};
  if (stateFilter) params.state_filter = stateFilter;
  if (mineOnly) params.mine_only = "true";
  const r = await api.get("/battles/feed/list", { params });
  return r.data.battles || [];
}

// Feb 14, 2026 PM — Past Battles cleanup. Both contestants can delete a
// finished/aborted/declined/cancelled battle. Live/scheduled/ready battles
// must be cancelled first (400 otherwise).
export async function deleteBattle(battleId) {
  const r = await api.delete(`/battles/${battleId}`);
  return r.data;
}

export async function bulkDeleteBattles(battleIds) {
  const r = await api.post(`/battles/bulk-delete`, { battle_ids: battleIds });
  return r.data;
}

export async function listEligibleSilos() {
  const r = await api.get("/battles/silos/eligible");
  return r.data.silos || [];
}

export async function downloadBattle(battleId, token) {
  const r = await api.get(`/battles/${battleId}/download`, { params: { token } });
  return r.data;
}

// May 12, 2026 — spectator-paced rounds. Anyone watching can press
// "Start next round" to advance a gated battle past its current pause.
// Idempotent server-side — the first caller wins, others are no-ops.
export async function advanceRound(battleId) {
  const r = await api.post(`/battles/${battleId}/advance-round`);
  return r.data;
}

